import { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );

  const login = (payload) => {
    // Accept either a string (email) or an object ({ email, phone, guest, ... })
    let data = null;
    if (typeof payload === "string") {
      data = { email: payload };
    } else if (payload && typeof payload === "object") {
      data = payload;
    }

    setUser(data);
    if (data) {
      localStorage.setItem("user", JSON.stringify(data));
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};